import {AbstractPlayableContent, TemporalIndicators} from "./AbstractPlayableContent";


// TODO: Could be rename ConsolidationPlayableContent
export class ListPlayableContent extends AbstractPlayableContent {
  readonly parentPlayableContent: AbstractPlayableContent;

  constructor(parentPlayableContent: AbstractPlayableContent, playableTimeline: AbstractPlayableContent[]) {
    if (playableTimeline.length === 0) {
      console.error('Trying to create a ListPlayableContent using an empty timeline')
    }

    let duration = 0;
    playableTimeline.forEach((playableContent) => {
      duration += playableContent.temporalIndicators.duration
    });

    const temporalIndicators = new TemporalIndicators(
      playableTimeline[0].temporalIndicators.startDivision,
      duration,
      playableTimeline[0].temporalIndicators.divisionPerBeat,
      playableTimeline[0].temporalIndicators.beatPerMeasure,
      playableTimeline[0].temporalIndicators.tempo,
    );

    super('list', parentPlayableContent.id, 'Enchainement', temporalIndicators, {}, playableTimeline);
    this.parentPlayableContent = parentPlayableContent;
  }

  get successModalName() {
    return "L'enchainement " + this.playableTimeline.map(content => content.name).join(', ');
  }
}
